import styled, { css } from 'styled-components';
import { ApprovalType } from '.';

export const Container = styled.div`
  display: flex;
  flex: 0;
  flex-direction: column;
  gap: 8px;
  border: 1px solid #E0E0E0;
  padding: 8px;
  border-radius: 4px;
  margin: 0px;
  position: relative;
`;

export const RemoveApprovalButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #FFF;
  color: #000;
  border: none;
  width: 24px;
  height: 24px;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s;
  position: absolute;
  right: 4px;
  top: 4px;

  &:hover {
    background-color: #F0F0F0;
  }

  svg {
    width: 16px;
    height: 16px;
  }
`;

export const Headline = styled.div`
  display: flex;
  align-items: center;
  gap: 2px;
`;

interface IApprovalTypeLabelProps {
  type: ApprovalType;
}

const approvalTypeLabelStyles = {
  APPROVED: {
    color: '#4D9C00',
  },
  ROUND_ROBIN_APPROVED: {
    color: '#4460BF',
  },
  REPPROVED: {
    color: '#F43232',
  },
  COMMENT: {
    color: '#B9A300',
  },
}

export const ApprovalTypeLabel = styled.span<IApprovalTypeLabelProps>`
  ${({ type }: IApprovalTypeLabelProps) => css`
    color: ${approvalTypeLabelStyles[type].color};
    font-size: 12px;
  `}
`;

export const ApprovalMemberName = styled.span`
  font-size: 14px;
  color: #000;
  font-weight: 600;
  font-family: 'Roboto', sans-serif;
`;

export const Caveat = styled.span`
  color: #000;
  font-weight: 400;
  font-family: Inter;
  font-size: 12px;
`;

export const RoundRobinDateContainer = styled.div`
  display: flex;
  gap: 8px;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 4px;
  border-bottom: 1px solid #6b6b6b;
  width: 70%;

  svg {
    height: 18px;
    width: 18px;
  }
`;

export const RoundRobinDate = styled.span`
  color: #000;
  font-weight: 400;
  font-family: 'Roboto', sans-serif;
  font-size: 12px;
  
`;
